export const APP_MODES = {
  NONE: '',
  ADVISOR: 'advisor',
  SELF_CARE_V1: 'self-care-v1',
  SELF_CARE_V2: 'self-care-v2',
  ADVISING_REPORT_PDF_GENERATOR: 'pdf',
  ADVISING_REPORT_MINOR_PDF_GENERATOR: 'pdf-minor',
  MINOR: 'minor',
} as const

export type AppMode = ValueOf<typeof APP_MODES>
